import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { RolesTable } from '~/components/settings/masterData/roles';

import { routeParams, validateSearch } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/masterdata/roles/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/masterdata/roles',
    ...routeParams,
  }),
  component: RolesTable,
  validateSearch,
});

export const MASTERDATA_ROLES = buildRouteExport({ Route, ...routeParams });
